package com.kinoshazam.view

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberUpdatedState
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.events.Event
import org.w3c.dom.events.KeyboardEvent

/**
 * Web has no system back. Escape closes the current overlay when [enabled].
 *
 * Skips Escape when:
 * - already [defaultPrevented] (e.g. web player handled FS → close), or
 * - document is fullscreen (player owns first Escape to exit FS).
 */
@Composable
actual fun OnBackPressed(enabled: Boolean, onBack: () -> Unit) {
    val latestOnBack by rememberUpdatedState(onBack)

    DisposableEffect(enabled) {
        if (!enabled) {
            return@DisposableEffect onDispose { }
        }

        val onKeyDown: (Event) -> Unit = onKeyDown@{ event ->
            val keyEvent = event as? KeyboardEvent ?: return@onKeyDown
            if (keyEvent.key != "Escape") return@onKeyDown
            if (keyEvent.defaultPrevented) return@onKeyDown
            val doc = document.asDynamic()
            val inFs = doc.fullscreenElement != null ||
                doc.webkitFullscreenElement != null ||
                doc.mozFullScreenElement != null ||
                doc.msFullscreenElement != null
            if (inFs) return@onKeyDown
            // Player overlay owns Escape while mounted.
            if (document.getElementById("kinoshka-player-root") != null) return@onKeyDown
            keyEvent.preventDefault()
            latestOnBack()
        }
        window.addEventListener("keydown", onKeyDown)

        onDispose {
            window.removeEventListener("keydown", onKeyDown)
        }
    }
}
